import React from 'react'
import {ClockLoader} from 'react-spinners'
// import { Spinner } from '@shopify/polaris'

import './styles.css'

const LoadingSpinner = () => {
  return (
    <div className="spinner-container">
      <ClockLoader size={50} color={"#FD6A4F"} />
    </div>
  )
}

export default LoadingSpinner
